import classnames from 'classnames';
import styles from './ScoreIndicator.module.css';

export interface IScoreIndicatorProps {
    color: 'danger' | 'emergency' | 'bad' | 'normal' | 'warning' | 'emergency--darken';
    direction?: 'right' | 'left';
    label: string;
    leftLabel?: string;
    maxValue?: number;
    minValue?: number;
    onlyBadge?: boolean;
    percentage: number;
    result: string;
    rightLabel?: string;
    value: number;
    variant?: 'default' | 'gradient' | 'edgedGradient' | 'hsdqEdgedGradient';
    widerDot?: boolean;
}

export function ScoreIndicator(props: IScoreIndicatorProps) {
    const className = props.color === 'normal' ? 'has-background-success' : `has-background-${props.color}`;

    const sliderClassName = {
        [styles.gradientSlider]: props.variant === 'gradient',
        [styles.slider]: !props.variant || props.variant === 'default',
        [styles.edgedGradient]: props.variant === 'edgedGradient',
        [styles.hsdqEdgedGradient]: props.variant === 'hsdqEdgedGradient',
    };
    if (props.onlyBadge) {
        return (
            <div
                className={classnames(styles.dot, props.widerDot ? styles.dot + ' ' + styles.widerDot : '', className)}
                style={{ position: 'static', top: 'auto', transform: 'none', marginLeft: 'auto' }}
            >
                <p>{props.value}</p>
            </div>
        );
    } else {
        return (
            <div className={styles.wrapper}>
                <div className="row align-items-center">
                    <div className="col col-form-label">
                        <p>{props.label}</p>
                    </div>
                    <div className="col-sm-10 col-xl-12">
                        <div className={styles.sliderWrap}>
                            {props.leftLabel && (
                                <div className={classnames(styles.leftLabel, 'muted')}>{props.leftLabel}</div>
                            )}
                            <div className={classnames(sliderClassName)}>
                                {props.variant === 'default' && (
                                    <div
                                        className={classnames(styles.bar, className)}
                                        style={{ width: props.percentage + '%' }}
                                    ></div>
                                )}
                                {(!props.direction || props.direction === 'left') && (
                                    <div
                                        className={classnames(
                                            styles.dot,
                                            props.widerDot ? styles.dot + ' ' + styles.widerDot : '',
                                            className
                                        )}
                                        style={{ left: 100 - props.percentage + '%' }}
                                    >
                                        <p>{props.value}</p>
                                    </div>
                                )}
                                {props.direction === 'right' && (
                                    <div
                                        className={classnames(
                                            styles.dot,
                                            props.widerDot ? styles.dot + ' ' + styles.widerDot : '',
                                            className
                                        )}
                                        style={{ left: props.percentage + '%' }}
                                    >
                                        <p>{props.value}</p>
                                    </div>
                                )}
                            </div>
                            {props.rightLabel && (
                                <div className={classnames(styles.rightLabel, 'muted')}>{props.rightLabel}</div>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-8 col-xl-6">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <p className="font-weight-bold">{props.result}</p>
                                </div>
                            </div>
                            {props.minValue && props.maxValue && (
                                <div className="level-left">
                                    <div className="level-item">
                                        <p>
                                            ({props.minValue}-{props.maxValue})
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
